<template>
  <div>
    <section />
    <form>
      <div
        class="subscriptions-view"
      >
        <!-- Email Notifications Card -->
        <b-card class="mb-1">
          <b-media>
            <p class="media-heading d-flex justify-content-between">
              <span class="font-weight-bolder">Email Notifications</span>
            </p>
            <hr>
            <b-form-checkbox
              v-for="type in emailNotificationTypes"
              :key="type.id"
              v-model="type.checked"
              @change="handleCheckbox($event, type.id)"
            >
              {{ type.name }}
            </b-form-checkbox>
          </b-media>
        </b-card>
      </div>
      <!-- Other subscription options could be added here -->
    </form>
  </div>
</template>

<script>

import UserNotificationService from '@/api/client/userNotification.service'

export default {
  name: 'Subscriptions',
  data() {
    return {
      userNotifications: {},
      notificationTypes: [],
      unsubscribedNotificationIds: [],
      emailNotificationTypes: [],
    }
  },

  computed: {
    accountId() {
      return this.$route.params.accountId
    },
  },

  watch: {
    accountId(newAccountId, oldAccountId) {
      if (newAccountId !== oldAccountId) {
        this.resetNotifications()
        this.fetchUserNotifications()
        this.fetchNotificationTypes()
      }
    },
  },

  mounted() {
    this.fetchUserNotifications()
    this.fetchNotificationTypes()
  },

  methods: {
    resetNotifications() {
      this.unsubscribedEmailNotificationIds = []
      this.userNotifications = {}
    },

    async fetchUserNotifications() {
      try {
        const userNotifications = await UserNotificationService.getAll(this.$route.params.accountId)
        this.unsubscribedEmailNotificationIds = userNotifications.filter(notif => notif.type === 2).map(notif => notif.notificationType)
      } catch (error) {
        console.error('Failed to fetch user notifications:', error)
      }
    },

    async handleCheckbox(isChecked, typeId) {
      const userNotificationType = 2
      try {
        const userNotifications = await UserNotificationService.getAll(this.accountId)
        const specificNotification = userNotifications.find(notif => notif.notificationType === typeId && notif.type === userNotificationType)
        if (isChecked && specificNotification) {
          await UserNotificationService.delete(specificNotification.id)
          this.$toast.success('You have subscribed successfully.')
        } else if (!isChecked && !specificNotification) {
          const model = {
            UserId: this.accountId,
            NotificationType: typeId,
            Type: userNotificationType,
          }
          await UserNotificationService.insert(model)
          this.$toast.success('You have unsubscribed successfully.')
        }
      } catch (error) {
        console.error('Failed to update subscription:', error)
        this.$toast.error('Failed to update subscription.')
      }
    },

    async fetchNotificationTypes() {
      try {
        const notificationTypes = await UserNotificationService.getNotificationTypes()
        await this.fetchUserNotifications()
        this.emailNotificationTypes = notificationTypes.map(type => ({
          ...type,
          checked: !this.unsubscribedEmailNotificationIds.includes(type.id),
        }))
      } catch (error) {
        console.error('Failed to fetch notification types:', error)
        this.notificationTypes = []
      }
    },
  },
}

</script>

<style lang="scss">
@import '@/assets/scss/views/client/account/subscriptions.scss';
</style>
